import { PINCODE_TYPE } from '../../types/location.types';
import { createSelector } from 'reselect';

const defaultPinCodesSelector = (state) => state.location.get('defaultPinCodes');

export const selectDefaultPinCodes = createSelector(defaultPinCodesSelector, (defaultPinCodes) => {
  const defaultSmartlockPinCodes = defaultPinCodes.filter(({type}) => type != PINCODE_TYPE.CLEANING);
  const defaultTtlockPinCodes = defaultPinCodes;
  return ({
    defaultSmartlockPinCodes,
    defaultTtlockPinCodes,
  });
});